import React from "react";
import { Icon } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";

export default () => {
	const { t } = useTranslation();
	return (
		<div className="container" style={{ height: "100vh" }}>
			<div
				className="d-flex justify-content-center text-center align-items-center"
				style={{ height: "100vh" }}>
				<div
					className="align-self-center"
					style={{ marginTop: "-20%" }}>
					<Icon
						type="frown-open"
						size="4x"
						className="mb-4 text-muted"
					/>
					<h1>404</h1>
					<p>{t("alerts.pageError")}</p>
				</div>
			</div>
		</div>
	);
};
